/* AGS Resource Hub — viewer, filters, search, interchange. No dependencies; PDF.js loads on demand. */
(function () {
  'use strict';
  if (window.AGSH) return;
  var PDFJS_VER = '3.11.174';
  var PDFJS_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/' + PDFJS_VER + '/pdf.min.js';
  var PDFJS_WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/' + PDFJS_VER + '/pdf.worker.min.js';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ICON = {
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    fit: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>',
    dl: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4v11m0 0-4-4m4 4 4-4M5 20h14"/></svg>',
    ext: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    thumbs: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3" y="4" width="5" height="7" rx="1"/><rect x="10" y="4" width="5" height="7" rx="1"/><rect x="17" y="4" width="4" height="7" rx="1"/><path d="M3 16h18M3 20h12"/></svg>'
  };

  /* ---------------- helpers ---------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, attrs, html) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { if (attrs[k] != null) n.setAttribute(k, attrs[k]); });
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function compact(s) { return norm(s).replace(/[^a-z0-9]/g, ''); }
  function matches(hay, q) {
    if (!q) return true;
    var h = norm(hay), hc = compact(hay);
    return q.split(/\s+/).filter(Boolean).every(function (t) { return h.indexOf(t) > -1 || (compact(t).length > 1 && hc.indexOf(compact(t)) > -1); });
  }
  function highlight(text, q) {
    var safe = esc(text);
    if (!q) return safe;
    var terms = q.split(/\s+/).filter(function (t) { return t.length > 1; }).map(function (t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!terms.length) return safe;
    return safe.replace(new RegExp('(' + terms.join('|') + ')', 'ig'), '<mark>$1</mark>');
  }
  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }

  var pdfjsPromise = null;
  function loadPdfjs() {
    if (pdfjsPromise) return pdfjsPromise;
    pdfjsPromise = new Promise(function (resolve, reject) {
      if (window.pdfjsLib) { window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER; return resolve(window.pdfjsLib); }
      var s = document.createElement('script');
      s.src = PDFJS_SRC; s.async = true;
      s.onload = function () {
        if (!window.pdfjsLib) return reject(new Error('pdfjs missing'));
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER;
        resolve(window.pdfjsLib);
      };
      s.onerror = function () { reject(new Error('pdfjs load failed')); };
      document.head.appendChild(s);
    });
    return pdfjsPromise;
  }
  var docCache = {};
  function getDoc(url) {
    if (docCache[url]) return docCache[url];
    docCache[url] = loadPdfjs().then(function (lib) {
      return lib.getDocument({ url: url, rangeChunkSize: 262144, disableAutoFetch: true, disableStream: false }).promise;
    });
    docCache[url].catch(function () { delete docCache[url]; });
    return docCache[url];
  }

  /* ---------------- Viewer ---------------- */
  function Viewer(root, opts) {
    this.root = root; this.opts = opts || {};
    this.pdf = null; this.page = 1; this.zoom = 1; this.textCache = {}; this.hits = []; this.hitIdx = -1;
    this.build();
  }
  Viewer.prototype.build = function () {
		var o = this.opts, self = this;
		var startUrl = esc(this.root.getAttribute('data-pdf') || '');
		var startHref = startUrl ? ' href="' + startUrl + '"' : '';
    this.root.classList.add('agsh-viewer');
    this.root.innerHTML =
      '<div class="agsh-viewer__bar">' +
        '<div class="agsh-viewer__title"></div>' +
        '<div class="agsh-viewer__find"><input type="search" placeholder="Search in document" aria-label="Search in document"><span class="agsh-viewer__hits" aria-live="polite"></span></div>' +
        '<div class="agsh-viewer__page"><input type="text" inputmode="numeric" aria-label="Page number" value="1"><span>/ <b class="agsh-total">–</b></span></div>' +
        '<button class="agsh-vbtn" data-act="zoomout" aria-label="Zoom out">' + ICON.minus + '</button>' +
        '<button class="agsh-vbtn" data-act="zoomin" aria-label="Zoom in">' + ICON.plus + '</button>' +
        '<button class="agsh-vbtn" data-act="fit" aria-label="Fit to screen">' + ICON.fit + '</button>' +
        (o.thumbs ? '<button class="agsh-vbtn" data-act="thumbs" aria-label="Toggle page thumbnails" aria-pressed="true">' + ICON.thumbs + '</button>' : '') +
				'<a class="agsh-vbtn" data-act="ext"' + startHref + ' target="_blank" rel="noopener" aria-label="Open in new tab">' + ICON.ext + '</a>' +
				'<a class="agsh-vbtn" data-act="dl"' + startHref + ' download aria-label="Download PDF">' + ICON.dl + '</a>' +
        (o.modal ? '<button class="agsh-vbtn" data-act="close" aria-label="Close viewer">' + ICON.close + '</button>' : '') +
      '</div>' +
      '<div class="agsh-viewer__stage" tabindex="0">' +
        '<button class="agsh-viewer__nav agsh-viewer__nav--prev" data-act="prev" aria-label="Previous page">' + ICON.prev + '</button>' +
        '<div class="agsh-viewer__spread"></div>' +
        '<button class="agsh-viewer__nav agsh-viewer__nav--next" data-act="next" aria-label="Next page">' + ICON.next + '</button>' +
        '<div class="agsh-viewer__msg"><div class="agsh-spin"></div><div>Loading…</div></div>' +
      '</div>' +
		(o.thumbs ? '<div class="agsh-viewer__thumbs" role="group" aria-label="Pages"></div>' : '');
    this.$title = $('.agsh-viewer__title', this.root);
    this.$stage = $('.agsh-viewer__stage', this.root);
    this.$spread = $('.agsh-viewer__spread', this.root);
    this.$msg = $('.agsh-viewer__msg', this.root);
    this.$pageIn = $('.agsh-viewer__page input', this.root);
    this.$total = $('.agsh-total', this.root);
    this.$find = $('.agsh-viewer__find input', this.root);
    this.$hits = $('.agsh-viewer__hits', this.root);
    this.$thumbs = $('.agsh-viewer__thumbs', this.root);
    this.root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b || !self.root.contains(b)) return;
      var a = b.getAttribute('data-act');
      if (a === 'prev') self.go(self.page - self.step(-1));
      else if (a === 'next') self.go(self.page + self.step(1));
      else if (a === 'zoomin') { self.zoom = Math.min(4, self.zoom * 1.25); self.render(); }
      else if (a === 'zoomout') { self.zoom = Math.max(.5, self.zoom / 1.25); self.render(); }
      else if (a === 'fit') { self.zoom = 1; self.render(); }
      else if (a === 'thumbs') { var on = self.$thumbs.classList.toggle('agsh-hidden'); b.setAttribute('aria-pressed', on ? 'false' : 'true'); self.render(); }
      else if (a === 'close' && self.opts.onClose) self.opts.onClose();
    });
    this.$pageIn.addEventListener('change', function () { var n = parseInt(self.$pageIn.value, 10); if (n) self.go(n); });
    this.$find.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.find(self.$find.value); } });
    this.$find.addEventListener('search', function () { if (!self.$find.value) self.clearFind(); });
    this.$stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); self.go(self.page + self.step(1)); }
      if (e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); self.go(self.page - self.step(-1)); }
    });
    var sx = null;
    this.$stage.addEventListener('touchstart', function (e) { if (e.touches.length === 1 && self.zoom === 1) sx = e.touches[0].clientX; }, { passive: true });
    this.$stage.addEventListener('touchend', function (e) {
      if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 50) self.go(self.page + (dx < 0 ? self.step(1) : -self.step(-1)));
    });
    var ro = window.ResizeObserver ? new ResizeObserver(debounce(function () { if (self.pdf) self.render(); }, 150)) : null;
    if (ro) ro.observe(this.$stage);
  };
  Viewer.prototype.isSpread = function () { return !!this.opts.spread && this.$stage.clientWidth >= 700 && this.zoom === 1; };
  Viewer.prototype.pagesFor = function (p) {
    if (!this.isSpread() || p === 1) return [p];
    var left = p % 2 === 0 ? p : p - 1;
    return left + 1 <= this.pdf.numPages ? [left, left + 1] : [left];
  };
  Viewer.prototype.step = function (dir) {
    if (!this.isSpread()) return 1;
    if (dir > 0) return this.page === 1 ? 1 : (this.page % 2 === 0 ? 2 : 1);
    return this.page <= 3 ? Math.max(1, this.page - 1) : (this.page % 2 === 0 ? 2 : 3);
  };
  Viewer.prototype.open = function (url, title) {
    var self = this;
    this.url = url; this.pdf = null; this.page = 1; this.zoom = 1; this.textCache = {}; this.clearFind();
    this.$title.textContent = title || '';
    $('[data-act="dl"]', this.root).href = url;
    $('[data-act="ext"]', this.root).href = url;
    this.$spread.innerHTML = ''; this.$total.textContent = '–';
    if (this.$thumbs) this.$thumbs.innerHTML = '';
    this.showMsg('<div class="agsh-spin"></div><div>Loading…</div>');
    var token = this.token = {};
    getDoc(url).then(function (pdf) {
      if (token !== self.token) return;
      self.pdf = pdf; self.$total.textContent = pdf.numPages;
      self.hideMsg(); self.render(); self.buildThumbs();
    }).catch(function () {
      if (token !== self.token) return;
      self.fallback();
    });
  };
  Viewer.prototype.fallback = function () {
    // PDF.js unavailable (network/CORS): use the browser's own PDF viewer.
    this.$spread.innerHTML = '';
    var url = this.url;
    var narrow = window.innerWidth < 750;
    if (narrow) {
      this.showMsg('<div>This document opens best in your device’s PDF viewer.</div><a class="agsh-btn agsh-btn--red" href="' + esc(url) + '" target="_blank" rel="noopener">Open PDF</a>');
    } else {
      this.hideMsg();
      this.$stage.style.padding = '0';
      this.$spread.style.cssText = 'width:100%;height:100%;box-shadow:none';
      this.$spread.innerHTML = '<iframe src="' + esc(url) + '#view=FitH" title="' + esc(this.$title.textContent) + '"></iframe>';
      $$('.agsh-viewer__nav,.agsh-viewer__find,.agsh-viewer__page,[data-act="zoomin"],[data-act="zoomout"],[data-act="fit"],[data-act="thumbs"]', this.root).forEach(function (n) { n.classList.add('agsh-hidden'); });
    }
  };
  Viewer.prototype.showMsg = function (h) { this.$msg.innerHTML = h; this.$msg.classList.remove('agsh-hidden'); };
  Viewer.prototype.hideMsg = function () { this.$msg.classList.add('agsh-hidden'); };
  Viewer.prototype.go = function (p) {
    if (!this.pdf) return;
    p = Math.max(1, Math.min(this.pdf.numPages, p));
    if (p === this.page) return;
    var dir = p > this.page ? 1 : -1;
    this.page = p; this.render(dir);
  };
  Viewer.prototype.render = function (dir) {
    if (!this.pdf) return;
    var self = this, pages = this.pagesFor(this.page), token = this.rtoken = {};
    this.$pageIn.value = pages.join('–');
    $('[data-act="prev"]', this.root).disabled = this.page <= 1;
    $('[data-act="next"]', this.root).disabled = pages[pages.length - 1] >= this.pdf.numPages;
    Promise.all(pages.map(function (n) { return self.pdf.getPage(n); })).then(function (pp) {
      if (token !== self.rtoken) return;
      var stageW = self.$stage.clientWidth - 36, stageH = self.$stage.clientHeight - 36;
      var vps = pp.map(function (p) { return p.getViewport({ scale: 1 }); });
      var totalW = vps.reduce(function (a, v) { return a + v.width; }, 0), maxH = Math.max.apply(null, vps.map(function (v) { return v.height; }));
      var fit = Math.min(stageW / totalW, (self.opts.fitHeight === false ? Infinity : stageH / maxH));
      if (!isFinite(fit) || fit <= 0) fit = stageW / totalW;
      var scale = fit * self.zoom, dpr = Math.min(window.devicePixelRatio || 1, 2.5);
      var frag = document.createDocumentFragment(), jobs = [];
      pp.forEach(function (p) {
        var vp = p.getViewport({ scale: scale * dpr });
        var c = document.createElement('canvas');
        c.width = Math.floor(vp.width); c.height = Math.floor(vp.height);
        c.style.width = Math.floor(vp.width / dpr) + 'px'; c.style.height = Math.floor(vp.height / dpr) + 'px';
        c.setAttribute('aria-label', 'Page ' + p.pageNumber);
        frag.appendChild(c);
        jobs.push(p.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise);
      });
      var swap = function () {
        if (token !== self.rtoken) return;
        self.$spread.innerHTML = ''; self.$spread.appendChild(frag);
        self.$spread.classList.remove('is-turning');
        self.$stage.style.alignItems = self.zoom > 1 ? 'flex-start' : (self.$stage.clientHeight > maxH * scale + 36 ? 'center' : 'flex-start');
        self.markThumb();
      };
      Promise.all(jobs).then(function () {
        if (dir && !reduceMotion) {
          self.$spread.style.setProperty('--agsh-turn', (dir > 0 ? -24 : 24) + 'px');
          self.$spread.classList.add('is-turning');
          setTimeout(swap, 140);
        } else swap();
      });
    });
  };
  Viewer.prototype.buildThumbs = function () {
    if (!this.$thumbs || !this.pdf) return;
    var self = this, n = this.pdf.numPages, frag = document.createDocumentFragment();
    for (var i = 1; i <= n; i++) {
      var b = el('button', { 'class': 'agsh-thumb', 'data-p': i, 'aria-label': 'Go to page ' + i }, '<b>' + i + '</b>');
      frag.appendChild(b);
    }
    this.$thumbs.appendChild(frag);
    this.$thumbs.addEventListener('click', function (e) { var b = e.target.closest('.agsh-thumb'); if (b) self.go(+b.getAttribute('data-p')); });
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return; io.unobserve(en.target);
        var p = +en.target.getAttribute('data-p');
        self.pdf.getPage(p).then(function (pg) {
          var vp = pg.getViewport({ scale: 1 }); var s = 120 / vp.width; var v2 = pg.getViewport({ scale: s });
          var c = document.createElement('canvas'); c.width = v2.width; c.height = v2.height;
          en.target.insertBefore(c, en.target.firstChild);
          pg.render({ canvasContext: c.getContext('2d'), viewport: v2 });
        });
      });
    }, { root: this.$thumbs, rootMargin: '0px 400px' });
    $$('.agsh-thumb', this.$thumbs).forEach(function (t) { io.observe(t); });
    this.markThumb();
  };
  Viewer.prototype.markThumb = function () {
    if (!this.$thumbs) return;
    var pages = this.pdf ? this.pagesFor(this.page) : [];
    $$('.agsh-thumb', this.$thumbs).forEach(function (t) {
      var on = pages.indexOf(+t.getAttribute('data-p')) > -1; t.classList.toggle('is-active', on);
      if (on && pages[0] === +t.getAttribute('data-p')) { var r = t.parentNode; r.scrollTo({ left: t.offsetLeft - r.clientWidth / 2 + t.clientWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' }); }
    });
  };
  Viewer.prototype.clearFind = function () {
    this.hits = []; this.hitIdx = -1; this.lastQ = '';
    if (this.$hits) this.$hits.textContent = '';
    if (this.$thumbs) $$('.agsh-thumb.is-hit', this.$thumbs).forEach(function (t) { t.classList.remove('is-hit'); });
  };
  Viewer.prototype.pageText = function (n) {
    var self = this;
    if (this.textCache[n] != null) return Promise.resolve(this.textCache[n]);
    return this.pdf.getPage(n).then(function (p) { return p.getTextContent(); }).then(function (tc) {
      var s = tc.items.map(function (i) { return i.str; }).join(' ');
      self.textCache[n] = s; return s;
    });
  };
  Viewer.prototype.find = function (q) {
    var self = this; q = (q || '').trim();
    if (!this.pdf || !q) return this.clearFind();
    if (q === this.lastQ && this.hits.length) {
      this.hitIdx = (this.hitIdx + 1) % this.hits.length;
      this.$hits.textContent = (this.hitIdx + 1) + ' of ' + this.hits.length + ' pages';
      this.page = 0; return this.go(this.hits[this.hitIdx]);
    }
    this.clearFind(); this.lastQ = q;
    var n = this.pdf.numPages, i = 1, found = [], cq = compact(q), nq = norm(q);
    this.$hits.textContent = 'Searching…';
    var next = function () {
      if (self.lastQ !== q) return;
      if (i > n) {
        self.hits = found;
        if (!found.length) { self.$hits.textContent = 'No matches'; return; }
        self.hitIdx = 0; self.$hits.textContent = '1 of ' + found.length + ' pages';
        if (self.$thumbs) found.forEach(function (p) { var t = $('.agsh-thumb[data-p="' + p + '"]', self.$thumbs); if (t) t.classList.add('is-hit'); });
        self.page = 0; self.go(found[0]); return;
      }
      var batch = [];
      for (var k = 0; k < 8 && i <= n; k++, i++) batch.push(self.pageText(i).then((function (pn) { return function (s) { var t = norm(s); if (t.indexOf(nq) > -1 || (cq.length > 2 && compact(s).indexOf(cq) > -1)) found.push(pn); }; })(i)));
      Promise.all(batch).then(function () { self.$hits.textContent = 'Searching… ' + Math.round(Math.min(i - 1, n) / n * 100) + '%'; next(); });
    };
    next();
  };

  /* ---------------- Modal ---------------- */
  var modal = null, modalViewer = null, lastFocus = null;
  function openModal(url, title) {
    if (!modal) {
      modal = el('div', { 'class': 'agsh agsh-modal', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Document viewer', hidden: '' });
      var box = el('div');
      modal.appendChild(box); document.body.appendChild(modal);
      modalViewer = new Viewer(box, { modal: true, thumbs: true, onClose: closeModal });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
    }
    lastFocus = document.activeElement;
    modal.hidden = false; document.body.classList.add('agsh-lock');
    modalViewer.open(url, title);
    setTimeout(function () { modalViewer.$stage.focus(); }, 50);
    if (window.history && history.replaceState) { try { history.replaceState(null, '', '#doc=' + encodeURIComponent(url.split('/files/').pop().split('?')[0])); } catch (e) {} }
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true; document.body.classList.remove('agsh-lock');
    modalViewer.token = {}; modalViewer.$spread.innerHTML = '';
    if (location.hash.indexOf('#doc=') === 0 && history.replaceState) { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-agsh-open]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    openModal(a.getAttribute('data-pdf') || a.getAttribute('href'), a.getAttribute('data-title') || a.textContent.trim());
  });

  /* ---------------- Covers ---------------- */
  var coverQueue = [], coverActive = 0;
  function pumpCovers() {
    while (coverActive < 2 && coverQueue.length) {
      var btn = coverQueue.shift(); coverActive++;
      (function (b) {
        getDoc(b.getAttribute('data-pdf')).then(function (pdf) { return pdf.getPage(1); }).then(function (pg) {
          var w = b.clientWidth || 240, dpr = Math.min(window.devicePixelRatio || 1, 2);
          var vp1 = pg.getViewport({ scale: 1 }), vp = pg.getViewport({ scale: (w * dpr) / vp1.width });
          var c = document.createElement('canvas'); c.width = vp.width; c.height = vp.height;
          return pg.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise.then(function () {
            c.setAttribute('aria-hidden', 'true'); b.insertBefore(c, b.firstChild);
            var ph = $('.agsh-card__ph', b); if (ph) ph.style.opacity = '0';
          });
        }).catch(function () {}).then(function () { coverActive--; pumpCovers(); });
      })(btn);
    }
  }
  function initCovers(root) {
    var covers = $$('[data-agsh-cover]', root);
    if (!covers.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting && en.target.offsetParent !== null) { io.unobserve(en.target); coverQueue.push(en.target); pumpCovers(); } });
    }, { rootMargin: '200px' });
    covers.forEach(function (c) { io.observe(c); });
    root.__agshCoverIO = io;
  }

  /* ---------------- Filterable lists (documents + SDS) ---------------- */
  function initList(root) {
    var items = $$('[data-agsh-item]', root);
    if (root.hasAttribute('data-agsh-sort')) {
      var parents = [];
      items.forEach(function (n) { if (parents.indexOf(n.parentNode) < 0) parents.push(n.parentNode); });
      parents.forEach(function (par) {
        var kids = items.filter(function (n) { return n.parentNode === par && n.hasAttribute('data-sort'); });
        kids.sort(function (a, b) { return (+a.getAttribute('data-sort') || 0) - (+b.getAttribute('data-sort') || 0); });
        kids.forEach(function (n) { par.appendChild(n); });
      });
      items = $$('[data-agsh-item]', root);
    }
    var input = $('[data-agsh-q]', root), typeSel = $('[data-agsh-type]', root), chips = $$('[data-agsh-cat]', root);
    var countEl = $('[data-agsh-count]', root), empty = $('[data-agsh-empty]', root), moreBtn = $('[data-agsh-more]', root);
    var limit = parseInt(root.getAttribute('data-agsh-limit'), 10) || 0, expanded = false, cat = '', type = '';
    function apply() {
      var q = norm(input ? input.value.trim() : ''), shown = 0, total = 0;
      items.forEach(function (n) {
        var ok = (!cat || n.getAttribute('data-cat') === cat) && (!type || n.getAttribute('data-type') === type) && matches(n.getAttribute('data-search'), q);
        if (ok) total++;
        var vis = ok && (expanded || q || cat || type || !limit || shown < limit);
        if (vis) shown++;
        n.classList.toggle('agsh-hidden', !vis);
        $$('[data-agsh-hl]', n).forEach(function (h) { if (!h.__orig) h.__orig = h.textContent; h.innerHTML = highlight(h.__orig, q); });
      });
      if (countEl) countEl.textContent = total + (total === 1 ? ' result' : ' results');
      if (empty) empty.classList.toggle('agsh-hidden', total > 0);
      if (moreBtn) moreBtn.parentNode.classList.toggle('agsh-hidden', expanded || !!(q || cat || type) || !limit || items.length <= limit);
      if (root.__agshCoverIO) $$('[data-agsh-cover]', root).forEach(function (c) { if (!c.querySelector('canvas')) { root.__agshCoverIO.unobserve(c); root.__agshCoverIO.observe(c); } });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        cat = c.getAttribute('data-agsh-cat');
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        apply();
      });
    });
    if (input) input.addEventListener('input', debounce(apply, 120));
    if (typeSel) typeSel.addEventListener('change', function () { type = typeSel.value; apply(); });
    if (moreBtn) moreBtn.addEventListener('click', function () { expanded = true; apply(); });
    root.__agshSet = function (o) {
      if (o.type != null && typeSel) { typeSel.value = o.type; type = o.type; }
      if (o.q != null && input) input.value = o.q;
      if (o.cat != null) { cat = o.cat; chips.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-agsh-cat') === cat ? 'true' : 'false'); }); }
      apply();
    };
    apply();
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-agsh-filter]'); if (!a) return;
    var target = document.getElementById(a.getAttribute('data-agsh-filter'));
    if (!target) return; e.preventDefault();
    if (target.__agshSet) target.__agshSet({ type: a.getAttribute('data-type') || '', cat: a.getAttribute('data-cat') || '', q: '' });
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------------- Interchange ---------------- */
  var ixData = null, ixPromise = null;
  function loadIx(src) {
    if (ixPromise) return ixPromise;
    var getJ = function (u) { return fetch(u, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); };
    ixPromise = getJ(src).then(function (rows) {
      if (rows && rows.b && rows.g && rows.more && rows.more.length) {
        var base = src.split('?')[0].replace(/[^\/]*$/, '');
        return Promise.all(rows.more.map(function (n) { return getJ(base + n + '?v=' + encodeURIComponent(rows.v || '1')); })).then(function (extra) {
          extra.forEach(function (x) { if (x && x.g) rows.g = rows.g.concat(x.g); });
          return rows;
        });
      }
      return rows || [];
    }).then(function (rows) {
      if (rows && rows.b && rows.g) {
        var flat = [];
        rows.g.forEach(function (g) { var xs = String(g[1]).split('|'); String(g[0]).split(' ').forEach(function (a) { xs.forEach(function (e) { var i = e.indexOf(':'); flat.push([a, rows.b[+e.slice(0, i)] || '', e.slice(i + 1)]); }); }); });
        flat.sort(function (x, y) { return x[0] < y[0] ? -1 : x[0] > y[0] ? 1 : 0; });
        rows = flat;
      }
      ixData = (Array.isArray(rows) ? rows : (rows.rows || [])).map(function (r) {
        var ags = r[0] || r.ags || '', brand = r[1] || r.brand || '', part = r[2] || r.part || '';
        return { ags: String(ags), brand: String(brand), part: String(part), k: compact(ags) + '|' + compact(part) };
      });
      return ixData;
    });
    return ixPromise;
  }
  function ixSearch(q, max) {
    var c = compact(q); if (!c || !ixData) return [];
    var exact = [], partial = [];
    for (var i = 0; i < ixData.length; i++) {
      var r = ixData[i], a = compact(r.ags), p = compact(r.part);
      if (a === c || p === c) exact.push(r);
      else if (c.length >= 2 && partial.length < (max || 200) && r.k.indexOf(c) > -1) partial.push(r);
    }
    return exact.concat(partial).slice(0, max || 200);
  }
  function initIx(root) {
    var src = root.getAttribute('data-src'), form = $('form', root), input = $('input', root), out = $('[data-agsh-ix-out]', root);
    var searchUrl = root.getAttribute('data-search-url') || '/search?q=';
    input.addEventListener('focus', function () { loadIx(src); }, { once: true });
    function run() {
      var q = input.value.trim();
      if (!q) { out.innerHTML = ''; return; }
      out.innerHTML = '<p class="agsh-ix__hint">Searching…</p>';
      loadIx(src).then(function (data) {
        if (!data.length) { out.innerHTML = '<div class="agsh-empty">The online lookup is being loaded with our latest interchange data. In the meantime, use the downloadable charts or <a href="' + esc(root.getAttribute('data-contact') || '/pages/contact') + '">ask our team</a>.</div>'; return; }
        var res = ixSearch(q, 200);
        if (!res.length) { out.innerHTML = '<div class="agsh-empty">No interchange found for <b>' + esc(q) + '</b>. Check the number or <a href="' + esc(root.getAttribute('data-contact') || '/pages/contact') + '">ask a tech</a>.</div>'; return; }
        var rows = res.slice(0, 100).map(function (r) {
          return '<tr><td><a href="' + esc(searchUrl + encodeURIComponent(r.ags)) + '">' + highlight(r.ags, q) + '</a></td><td>' + esc(r.brand) + '</td><td>' + highlight(r.part, q) + '</td></tr>';
        }).join('');
        out.innerHTML = '<p class="agsh-ix__hint">' + res.length + (res.length >= 200 ? '+' : '') + ' match' + (res.length === 1 ? '' : 'es') + (res.length > 100 ? ' — showing first 100' : '') + '</p><div class="agsh-table-scroll"><table><thead><tr><th>AGS part #</th><th>Brand</th><th>Their part #</th></tr></thead><tbody>' + rows + '</tbody></table></div>';
      });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); run(); });
    input.addEventListener('input', debounce(function () { if (input.value.trim().length >= 3) run(); else if (!input.value.trim()) out.innerHTML = ''; }, 250));
    root.__agshRun = function (q) { input.value = q; run(); };
  }

  /* ---------------- Global search ---------------- */
  function initGlobal(root) {
    var input = $('input', root), box = $('.agsh-results', root), idx = null, focus = -1;
    var ixRoot = $('[data-agsh-ix]');
    function build() {
      idx = $$('[data-agsh-item]').map(function (n) {
        return { n: n, t: n.getAttribute('data-title') || '', m: n.getAttribute('data-meta') || '', s: n.getAttribute('data-search') || '', g: n.getAttribute('data-group') || 'Resources', pdf: n.getAttribute('data-pdf'), href: n.getAttribute('data-href') };
      });
    }
    function render(q) {
      if (!idx) build();
      var qq = norm(q.trim());
      if (!qq) { box.classList.add('agsh-hidden'); input.setAttribute('aria-expanded', 'false'); return; }
      var groups = {}, order = [], count = 0;
      idx.forEach(function (r) {
        if (count >= 40 || !matches(r.s + ' ' + r.t, qq)) return;
        if (!groups[r.g]) { groups[r.g] = []; order.push(r.g); }
        if (groups[r.g].length < 8) { groups[r.g].push(r); count++; }
      });
      var html = '';
      order.forEach(function (g) {
        html += '<div class="agsh-results__grp">' + esc(g) + '</div>';
        groups[g].forEach(function (r) {
          var i = idx.indexOf(r);
          html += '<button type="button" class="agsh-results__item" data-i="' + i + '"><span><span>' + highlight(r.t, qq) + '</span><small>' + highlight(r.m, qq) + '</small></span></button>';
        });
      });
      if (ixRoot && ixData && ixData.length) {
        var ix = ixSearch(q, 6);
        if (ix.length) {
          html += '<div class="agsh-results__grp">Interchange</div>';
          ix.slice(0, 6).forEach(function (r) { html += '<button type="button" class="agsh-results__item" data-ix="' + esc(q) + '"><span><span>' + highlight(r.part, qq) + ' → <b>' + highlight(r.ags, qq) + '</b></span><small>' + esc(r.brand) + ' interchange</small></span></button>'; });
        }
      } else if (ixRoot && /\d/.test(q) && compact(q).length >= 3) {
        html += '<div class="agsh-results__grp">Interchange</div><button type="button" class="agsh-results__item" data-ix="' + esc(q) + '"><span><span>Look up “' + esc(q) + '” in the interchange</span><small>Cross a competitor or OE number to AGS</small></span></button>';
      }
      html += '<div class="agsh-results__grp">Products</div><a class="agsh-results__item" href="/search?q=' + encodeURIComponent(q) + '"><span><span>Search all products for “' + esc(q) + '”</span><small>Shop the AGS catalog</small></span></a>';
      box.innerHTML = html || '<div class="agsh-results__none">No matches.</div>';
      box.classList.remove('agsh-hidden'); input.setAttribute('aria-expanded', 'true'); focus = -1;
    }
    function choose(btn) {
      if (!btn) return;
      if (btn.hasAttribute('data-ix')) {
        box.classList.add('agsh-hidden');
        ixRoot.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        ixRoot.__agshRun && ixRoot.__agshRun(btn.getAttribute('data-ix'));
        return;
      }
      if (btn.tagName === 'A') { location.href = btn.href; return; }
      var r = idx[+btn.getAttribute('data-i')];
      box.classList.add('agsh-hidden');
      if (r.n.tagName === 'DETAILS') { r.n.open = true; r.n.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }); return; }
      if (r.pdf) { openModal(r.pdf, r.t); return; }
      if (r.href) { location.href = r.href; return; }
      var host = r.n.closest('[data-agsh-list]');
      if (host && host.__agshSet) host.__agshSet({ q: r.t, cat: '', type: '' });
      r.n.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
    input.addEventListener('input', debounce(function () { render(input.value); }, 100));
    input.addEventListener('focus', function () { if (ixRoot) loadIx(ixRoot.getAttribute('data-src')); if (input.value) render(input.value); });
    input.addEventListener('keydown', function (e) {
      var items = $$('.agsh-results__item', box);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); if (!items.length) return;
        focus = (focus + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach(function (x, i) { x.classList.toggle('is-focus', i === focus); });
        items[focus].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') { e.preventDefault(); choose(items[focus > -1 ? focus : 0]); }
      else if (e.key === 'Escape') { box.classList.add('agsh-hidden'); }
    });
    box.addEventListener('click', function (e) { var b = e.target.closest('.agsh-results__item'); if (b && b.tagName !== 'A') { e.preventDefault(); choose(b); } });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) box.classList.add('agsh-hidden'); });
    // active section highlighting
    var links = $$('.agsh-nav__links a', root.closest('.agsh-nav'));
    var map = {};
    links.forEach(function (a) { var id = (a.getAttribute('href') || '').replace('#', ''); var t = document.getElementById(id); if (t) map[id] = a; else a.classList.add('agsh-hidden'); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { links.forEach(function (l) { l.classList.remove('is-active'); }); var a = map[en.target.id]; if (a) { a.classList.add('is-active'); var pr = a.parentNode; pr.scrollTo({ left: a.getBoundingClientRect().left - pr.getBoundingClientRect().left + pr.scrollLeft - 24, behavior: reduceMotion ? 'auto' : 'smooth' }); } } });
      }, { rootMargin: '-45% 0px -50% 0px' });
      Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
    }
  }

  /* ---------------- Videos ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-agsh-yt]'); if (!b) return;
    var id = b.getAttribute('data-agsh-yt');
    var f = el('iframe', { src: 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0', title: b.getAttribute('aria-label') || 'Video', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture', allowfullscreen: '' });
    b.parentNode.replaceChild(f, b);
  });

  /* ---------------- Boot ---------------- */
  function boot(scope) {
    scope = scope || document;
    $$('[data-agsh-viewer]', scope).forEach(function (n) {
      if (n.__agsh) return;
      var v = new Viewer(n, { thumbs: n.getAttribute('data-thumbs') !== 'false', spread: n.getAttribute('data-spread') !== 'false' });
      n.__agsh = v;
      var start = function () { v.open(n.getAttribute('data-pdf'), n.getAttribute('data-title')); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) { if (ents[0].isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '300px' });
        io.observe(n);
      } else start();
    });
    $$('[data-agsh-list]', scope).forEach(function (n) { if (!n.__agshList) { n.__agshList = 1; initCovers(n); initList(n); } });
    $$('[data-agsh-ix]', scope).forEach(function (n) { if (!n.__agshIx) { n.__agshIx = 1; initIx(n); } });
    $$('[data-agsh-global]', scope).forEach(function (n) { if (!n.__agshG) { n.__agshG = 1; initGlobal(n); } });
    // deep link: #doc=filename.pdf opens the matching document
    if (scope === document && location.hash.indexOf('#doc=') === 0) {
      var fn = decodeURIComponent(location.hash.slice(5));
      var hit = $$('[data-pdf]').filter(function (x) { return (x.getAttribute('data-pdf') || '').indexOf('/' + fn) > -1; })[0];
      if (hit) openModal(hit.getAttribute('data-pdf'), hit.getAttribute('data-title'));
    }
  }
  window.AGSH = { boot: boot, open: openModal, Viewer: Viewer };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
